module.exports = __webpack_public_path__ + "static/media/parallax2_desktop.92948f01.png";